import { Input, List, ListItem } from '@chakra-ui/react';
import { FieldInputProps, FormikHelpers } from 'formik';
import { FC, useContext, useEffect, useState } from 'react';

import { ZipAddress } from '@/utils/types';

import { BookingFlowState } from './context/BookingFlowProvider';
import { GSAppContext } from './context/GSAppContext';

type FieldSetter<K> = FormikHelpers<K>['setFieldValue'];
type FieldToucher<K> = FormikHelpers<K>['setFieldTouched'];

const PostalCode: FC<
  {
    setFieldValue: FieldSetter<BookingFlowState>;
    setFieldTouched: FieldToucher<BookingFlowState>;
  } & FieldInputProps<ZipAddress>
> = ({ name, value: address, setFieldValue }) => {
  const {
    broker: { useAddressAutocomplete },
  } = useContext(GSAppContext);
  const [value, setValue] = useState(address?.postalCode || '');
  const { loading, timeAddresses: items } = useAddressAutocomplete(value);
  const [close, setClose] = useState(true);
  useEffect(() => {
    setValue(address?.postalCode || '');
  }, [address]);

  const onChange = (inputValue: string) => {
    setValue(inputValue || '');
    if (inputValue.length >= 5) setClose(false);
  };

  const onSelect = (selectedAddress: ZipAddress) => {
    setClose(true);
    setFieldValue(name, { ...address, ...selectedAddress });
  };

  return (
    <>
      <Input
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder="Zi&zwnj;p or po&zwnj;stal code"></Input>
      {!loading && items.length ? (
        <div className="relative z-10">
          <List
            position="absolute"
            border="thin solid #F0F0F0"
            borderRadius={5}
            className="bg-white"
            display={close ? 'none' : undefined}
            overflowY="auto"
            minWidth={180}
            minHeight={200}
            mt={0}
            py={2}>
            {items.map((item, index) => (
              <ListItem
                key={`${item.city}-${item.postalCode}-${index}`}
                transition="background-color 220ms, color 220ms"
                px={4}
                cursor="pointer"
                onClick={() => onSelect(item)}>
                <div className="flex flex-col text-sm my-1">
                  <div className="flex flex-row my-0 p-0">
                    {item.city}, {item.state}
                  </div>
                  <div className="flex flex-row my-0 p-0">
                    {item.postalCode}
                    {item.country === 'CAN' ? ', CAN' : ''}
                  </div>
                </div>
              </ListItem>
            ))}
          </List>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default PostalCode;
